import { useTranslation } from 'next-i18next'
import React from 'react'

import { TEST_LOCATORS } from '@src/constants/test-locators'
import { useStatsigDynamicConfig } from '@src/experiments/statsig-integration/use-statsig-dynamic-config.hook'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import * as dsStyles from './product-form-ds.styles'
import styles from './productForm.module.scss'

export function ProductSubscriptionTermsNotice() {
  const { t } = useTranslation('common')
  const subscriptionTermsUrl = useStatsigDynamicConfig<string>('subscriptionsTermsUrl')
  const isDS = shouldUseDesignSystem()

  return (
    <p
      className={isDS ? dsStyles.subscriptionTermsNoticeDsClass : styles.subscriptionTermsNotice}
      data-testid={TEST_LOCATORS.PRODUCT_FORM_SUBSCRIPTION_TERMS}
    >
      {t('pdp_subscription_terms_notice_prefix')}
      <a
        href={subscriptionTermsUrl}
        className={isDS ? dsStyles.subscriptionTermsNoticeLinkDsClass : styles.subscriptionTermsNotice__link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('pdp_subscription_terms_notice_link')}
      </a>
      {t('pdp_subscription_terms_notice_suffix')}
    </p>
  )
}
